<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents">
<div class="title-block">
<h1>Contents</h1>
</div>
<p class="toc1"><br/>
<span href="#/9781846274633_review" title="Link target outside of Sample">Review</span><br/>
<span href="#/9781846274633_booktitlepage" title="Link target outside of Sample">Title Page</span><br/>
<span href="#/9781846274633_dedication" title="Link target outside of Sample">Dedication</span><br/>
<span href="#/9781846274633_epigraph" title="Link target outside of Sample">Epigraph</span><br/>
<a href="#/9781846274633_chapter_01">I</a><br/>
<span href="#/9781846274633_chapter_02" title="Link target outside of Sample">II</span><br/>
<span href="#/9781846274633_chapter_03" title="Link target outside of Sample">III</span><br/>
<span href="#/9781846274633_chapter_04" title="Link target outside of Sample">IV</span><br/>
<span href="#/9781846274633_chapter_05" title="Link target outside of Sample">V</span><br/>
<span href="#/9781846274633_chapter_06" title="Link target outside of Sample">VI</span><br/>
<span href="#/9781846274633_chapter_07" title="Link target outside of Sample">VII</span><br/>
<span href="#/9781846274633_chapter_08" title="Link target outside of Sample">VIII</span><br/>
<span href="#/9781846274633_chapter_09" title="Link target outside of Sample">IX</span><br/>
<span href="#/9781846274633_chapter_10" title="Link target outside of Sample">X</span><br/>
<span href="#/9781846274633_chapter_11" title="Link target outside of Sample">XI</span><br/>
<span href="#/9781846274633_chapter_12" title="Link target outside of Sample">XII</span><br/>
<span href="#/9781846274633_chapter_13" title="Link target outside of Sample">XIII</span><br/>
<span href="#/9781846274633_chapter_14" title="Link target outside of Sample">XIV</span><br/>
<span href="#/9781846274633_chapter_15" title="Link target outside of Sample">XV</span><br/>
<span href="#/9781846274633_chapter_16" title="Link target outside of Sample">XVI</span><br/>
<span href="#/9781846274633_chapter_17" title="Link target outside of Sample">XVII</span><br/>
<span href="#/9781846274633_abouttheauthor" title="Link target outside of Sample">About the Author</span><br/>
<span href="#/9781846274633_insertedcopyright" title="Link target outside of Sample">Copyright</span><br/>
</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781846274633_toc.vue?21fad321